export default __webpack_public_path__ + "static/media/logo.4351de97.png";